import { useTranslation } from "react-i18next";
import { GrantRole } from "../../../../autogen/bff-api";
import { useNamesSourcingViewerAsMember } from "./useNamesSourcingViewerAsMember";

export const useGrantRoleName = () => {
  const { t } = useTranslation();
  const namesSourcingViewerAsMember = useNamesSourcingViewerAsMember();
  return (role: GrantRole): string => {
    switch (role) {
      case GrantRole.Owner:
        return t("Owner");
      case GrantRole.Admin:
        return t("Admin");
      case GrantRole.SourcingCreator:
        return t("Sourcing Creator");
      case GrantRole.SourcingViewer:
        return namesSourcingViewerAsMember ? t("Member") : t("Sourcing Viewer");
      case GrantRole.ContractCreator:
        return t("Contract Creator");
      case GrantRole.ContractViewer:
        return t("Contract Viewer");
      case GrantRole.ProjectCreator:
        return t("Project Creator");
      case GrantRole.ProjectViewer:
        return t("Project Viewer");
    }
  };
};
